import { RelaySDK } from '@fiverr-private/relay-sdk/dist/legacy';
import logger from '../../../logger/emitter';
import isDev from '../../../helpers/isDev';
import { getTraceId } from '../../../helpers/getTraceId';
import indifferentStatsListener from '../common';

/**
 * Register browser eventbus listener
 * @param  {String} options.host
 * @param  {String} [options.mode='production']
 * @return {undefined}
 */
export default function statsListener({ host, mode = 'production' } = {}) {
    const dev = isDev(mode);

    if (!dev && !host) {
        logger.warn(new Error(`OBS statsListener expected a "host" argument of an HTTP API URL (e.g. https://devnull.net/send-stat). instead got ${host}`));
        return;
    }

    /**
     * Backward compatibility with older OBS version for "host": Old URL
     * TODO: Remove this in the next major version (2.0.0)
     */
    host = /\/v\d\//.test(host) ? new URL(host).origin : host;
    const relaySDK = new RelaySDK({
        id: getTraceId(),
        endpoint: `${host}/v3/relay`
    });

    const action = dev
        ? (stat) => logger.info('Stat:', stat)
        : (stat = {}) => relaySDK.stat(stat);

    indifferentStatsListener({ action });
}
